var _path, _path2, _rect, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.22,8A1.9,1.9,0,0,1,38,10a1.9,1.9,0,0,1-1.77,2H27.75A1.9,1.9,0,0,1,26,10a1.9,1.9,0,0,1,1.76-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52,56H12a4,4,0,0,1-4-4V12a4,4,0,0,1,4-4h4a2,2,0,0,1,0,4H12V52H52V12H48.07a2,2,0,0,1,0-4H52a4,4,0,0,1,4,4V52A4,4,0,0,1,52,56Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 4,
    height: 8,
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42,36H28V26a2,2,0,1,0-4,0V38a2,2,0,0,0,2,2H42a2,2,0,0,0,0-4Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 6,
    width: 4,
    height: 8,
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.6487af0f.svg";
export { ForwardRef as ReactComponent };